import { Html } from '@react-three/drei'
import { Fragment } from 'react'
import { Vector2Tuple, Shape, Vector2 } from 'three'
import { uiToModel } from '~/components/DrawingCanvas/util/units'
import { getSegmentShape } from '~/components/DrawingCanvas/Walls/util'
import { useDistanceDimensions } from '~/hooks/useDistanceDimensions'
import { inputStyles } from '~/ui/Field'

export function WallMesh({
  edges,
  height,
  displayMeasures,
}: {
  edges: {
    insetEdges: [Vector2Tuple, Vector2Tuple][]
    outsetEdges: [Vector2Tuple, Vector2Tuple][]
    centerEdges: [Vector2Tuple, Vector2Tuple][]
  }
  height: number
  displayMeasures?: boolean
}) {
  const { displayFormattedValue } = useDistanceDimensions()

  const { centerEdges, insetEdges, outsetEdges } = edges
  const shapes: { shape: Shape; start: Vector2; end: Vector2; distance: number }[] = centerEdges.map(
    ([start, end], i) => {
      const [insetStart, insetEnd] = insetEdges[i]
      const [outsetStart, outsetEnd] = outsetEdges[i]
      const insetEdge = { start: new Vector2(...insetStart), end: new Vector2(...insetEnd) }
      return {
        shape: getSegmentShape({
          insetEdge,
          outsetEdge: { start: new Vector2(...outsetStart), end: new Vector2(...outsetEnd) },
        }),
        distance: uiToModel(insetEdge.start.distanceTo(insetEdge.end)),
        start: new Vector2(...start),
        end: new Vector2(...end),
      }
    }
  )

  return (
    <>
      {shapes.map(({ shape, start, end, distance }, i) => (
        <Fragment key={i}>
          <mesh>
            <extrudeGeometry args={[shape, { depth: height }]} />
            <meshStandardMaterial color={0x888888} />
          </mesh>
          {displayMeasures && (
            <Html
              position={[(start.x + end.x) / 2, (start.y + end.y) / 2, 0]}
              center
              className={inputStyles({
                isOnCanvas: true,
                class: 'pointer-events-none',
              })}
            >
              {displayFormattedValue(distance)}
            </Html>
          )}
        </Fragment>
      ))}
    </>
  )
}
